import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M10 3.6a3.9 3.9 0 1 0 0 7.8 3.9 3.9 0 0 0 0-7.8ZM4.9 7.5a5.1 5.1 0 1 1 10.2 0 5.1 5.1 0 0 1-10.2 0Zm2.479 7.4h4.62a.6.6 0 1 1 0 1.2H7.5c-1.438 0-2.025.006-2.486.146a3.4 3.4 0 0 0-2.267 2.267c-.14.461-.146 1.048-.146 2.487a.6.6 0 1 1-1.2 0v-.121c0-1.28 0-2.06.198-2.714a4.6 4.6 0 0 1 3.067-3.067C5.32 14.9 6.1 14.9 7.38 14.9Zm8.697.676a.6.6 0 0 1 .848 0L19 17.65l2.076-2.075a.6.6 0 1 1 .848.848L19.85 18.5l2.075 2.076a.6.6 0 0 1-.848.848L19 19.35l-2.076 2.075a.6.6 0 1 1-.848-.848L18.15 18.5l-2.075-2.076a.6.6 0 0 1 0-.848Z"
      clip-rule="evenodd"
    />
  </svg>
`;
